
export const LOCAL_STORE_KEY_PREFIX = "data_s_"
export const LOCAL_STORE_META_KEY = LOCAL_STORE_KEY_PREFIX + "meta"
export const LOCAL_STORE_ADMIN_KEY = LOCAL_STORE_KEY_PREFIX + "admin"

export abstract class DataSyncManagerBase
{
    protected readonly apiPrefix: string
    protected readonly localStorage: Storage

    public showError = (userMessage: any, logMessage?: any): void => {
        console.trace(logMessage || userMessage)
    }
    public showWarning = (userMessage: any): void => {
        console.warn(userMessage)
    }

    protected constructor(apiPrefix: string = '', localStorage_: Storage|null = null) {
        this.apiPrefix = apiPrefix.endsWith('/') ? apiPrefix.substring(0, apiPrefix.length-1) : apiPrefix
        this.localStorage = localStorage_ || localStorage
    }

    protected async checkResponse(response: Response, userErrorCodes: number[], errorMessage: string, additionalValidator: (result: any) => boolean = () => true): Promise<any>
    {
        if (userErrorCodes.includes(response.status)) {
            let result = await response.json();
            this.showWarning(result?.error || 'Unsuccessful response from server');
            return null
        }
        if (!response.ok) {
            this.showError(errorMessage, 'Error response from server');
            return null
        }
        let result = await response.json();
        if (!result || !additionalValidator(result)) {
            this.showError(errorMessage + (result?.error ? ": " + result.error : ""), 'Invalid response from server: ' + (result?.error || JSON.stringify(result)));
            return null
        }
        return result
    }

    protected async checkSuccessResponse(response: Response, userErrorCodes: number[], errorMessage: string, additionalValidator: (result: any) => boolean = () => true): Promise<any>
    {
        return this.checkResponse(response, userErrorCodes, errorMessage, (res) => res.success && additionalValidator(res))
    }
}